import cn from 'classnames';
import { useMemo } from 'react';

import { useTextStyle } from '@webapp/common/components/custom-styles';
import { CssPageBlock } from '@webapp/common/components/survey-custom';
import { setHtml } from '@webapp/common/lib/ui';

import { selectWelcomePageText } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

import { usePipingAnswersReplacer } from '../../machine/use-piping-answers-replacer';

import { SurveySection } from './container';

import css from './survey.css';

export const WelcomeText: FC<{
    marginStyles: CSSProperties;
    styles?: CSSProperties;
}> = ({ marginStyles, styles }) => {
    const welcomePageText = useStateSelector(selectWelcomePageText);
    const { itemsGap, textStyle } = useTextStyle();
    const pipingAnswersReplacer = usePipingAnswersReplacer();

    const startSectionStyles = useMemo(
        () => ({
            ...textStyle,
            paddingLeft: marginStyles.paddingLeft,
            paddingRight: marginStyles.paddingRight,
            paddingBottom: itemsGap,
        }),
        [itemsGap, marginStyles, textStyle],
    );

    return (
        <SurveySection
            className={cn(CssPageBlock.WELCOME, css.container, css.welcomeContainer)}
            style={startSectionStyles}
        >
            <div style={styles} className={css.welcomeText} {...setHtml(pipingAnswersReplacer(welcomePageText))} />
        </SurveySection>
    );
};
WelcomeText.displayName = 'WelcomeText';
